import styled from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';
import breakpoint from 'Styles/breakpoints';

import CardOriginal, {
  CardContent as CardContentOriginal
} from '../../../Card/Card';
import ButtonIcon from '../../../Icons/ButtonIcon';

export const Card = styled(CardOriginal)`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  &:focus {
    outline: 0;
    box-shadow: var(--primary) 0px 0px 1px 1px;
  }
`;

export const CardContent = styled(CardContentOriginal)`
  display: flex;
  align-items: center;
`;

export const Image = styled.div`
  height: 75px;
  width: 75px;
  margin-right: 16px;
`;

export const Copy = styled.div`
  flex: 1;
`;

export const Title = styled.h1`
  ${fontTitle(14)};
  color: var(--foreground);
  margin: 0;
  margin-bottom: 4px;

  ${breakpoint('medium')} {
    ${fontTitle(16)};
  }
`;

export const Description = styled.p`
  ${fontBody(14)};
  color: var(--foreground);
  margin: 0;

  ${breakpoint('medium')} {
    ${fontBody(16)};
  }
`;

export const CtaButton = styled(ButtonIcon).attrs({ variant: 'defaultLight' })`
  ${fontBody(16)};
  margin-left: auto;

  ${breakpoint('medium')} {
    ${fontBody(20)};
  }
`;
